import { defineStore } from 'pinia'

export const useCsrfStore = defineStore('csrf', {
  state: () => ({
    token: '',
  }),
  actions: {
    receiveToken(token: string) {
      this.token = token
    },
  },
})
